"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutBucketRequestPaymentOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=PutBucketRequestPaymentOutput.js.map